import { Text } from "@kanda-libs/ks-design-library";
import type { FunctionComponent } from "react";
import { CLASS_NAMES, TITLE } from "./constants";
import useJobWorkTypeProps from "./useJobWorkTypeProps";

export interface JobWorkTypeProps {}

const JobWorkType: FunctionComponent<JobWorkTypeProps> = function () {
  const { isLoading, workType = "" } = useJobWorkTypeProps();

  if (isLoading || !workType) {
    return <></>;
  }

  return (
    <div className={CLASS_NAMES.container}>
      <p className={CLASS_NAMES.title}>{TITLE}</p>
      <div className={CLASS_NAMES.content}>
        <Text className={CLASS_NAMES.description} text={workType} />
      </div>
    </div>
  );
};

export default JobWorkType;
